"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnvName = exports.ENVIRONMENTS = void 0;
// TODO this declaration should probably move elsewhere (and get a more complete definition!)
// but this is good enough for now...

/**
 * Helper constant to prevent typos when comparing EnvNames.
 */
var ENVIRONMENTS = exports.ENVIRONMENTS = {
  production: 'production',
  fra1: 'fra1',
  our1: 'our1',
  onprem: 'onprem',
  local: 'local'
};

/**
 * Mapping of process.env.ENV_NAME to user-friendly EnvName string.
 */
var ENV_NAME_MAPPING = {
  'US-SaaS': 'production',
  'EMEA-SaaS': 'fra1',
  OurPrem1: 'our1'
};

/**
 * Replacement for @kentik/lib/env getEnvName.
 */
var getEnvName = exports.getEnvName = function getEnvName() {
  return (
    // ENV_NAME is defined for all environments except local
    process.env.ENV_NAME == null ? 'local' : ENV_NAME_MAPPING[process.env.ENV_NAME] || 'onprem'
  );
};